export const toFixed = (value: string | number, fixed = 2): number => {
  const number = typeof value === 'string' ? +value : value;

  return parseFloat(number.toFixed(fixed));
}